/* Category bar hover panels.
   Products are fetched on first hover from the search.catpanel view and cached,
   so the header ships no product markup. Hover uses open/close delays so moving
   diagonally toward the panel does not close it. */
(function () {
  var OPEN_DELAY = 90, CLOSE_DELAY = 180;
  var bar = document.querySelector('.hdt-category-bar');
  if (!bar) return;

  var SUB_DELAY = 120;
  var openTimer, closeTimer, subTimer, current = null;
  // url -> Promise<html>, shared by every panel: a sub-type row fetched once is
  // instant on every later hover.
  var cache = {};
  var SKELETONS = new Array(7).join('<span class="hdt-catpanel__skeleton" aria-hidden="true"></span>');

  function panelFor(trigger) {
    var id = trigger.getAttribute('data-catpanel-trigger');
    return id ? bar.querySelector('#' + CSS.escape(id)) : null;
  }

  function fetchRow(url) {
    if (!cache[url]) {
      cache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) { return html.trim(); })
        .catch(function () { delete cache[url]; return ''; });
    }
    return cache[url];
  }

  /* Fill the panel's product row from `url`. The row remembers which url it
     wants, so a slow response for a type the pointer has already left is
     dropped instead of overwriting the newer row. */
  function showRow(panel, url) {
    var grid = panel.querySelector('[data-catpanel-products]');
    if (!grid || !url || grid.dataset.url === url) return;
    grid.dataset.url = url;
    grid.innerHTML = SKELETONS;
    grid.scrollLeft = 0;
    updateArrows(panel);
    fetchRow(url).then(function (html) {
      if (grid.dataset.url !== url) return;
      // Empty on failure: the link list stays usable, the skeletons go.
      grid.innerHTML = html;
      grid.scrollLeft = 0;
      updateArrows(panel);
    });
  }

  function load(panel) {
    var grid = panel.querySelector('[data-catpanel-products]');
    if (grid && !grid.dataset.url) showRow(panel, grid.getAttribute('data-fetch-url'));
  }

  /* Sub-links: hovering or focusing one shows that type's trending row and
     makes it the list's current item, which stays highlighted after the
     pointer leaves the list so moving across to the products keeps them. */
  function selectSub(link) {
    var panel = link.closest('[data-catpanel]');
    if (!panel) return;
    panel.querySelectorAll('.hdt-catpanel__sublink.is-current').forEach(function (a) {
      a.classList.remove('is-current');
    });
    link.classList.add('is-current');
    var label = panel.querySelector('[data-catpanel-trending]');
    if (label) label.textContent = link.getAttribute('data-catpanel-label') || '';
    showRow(panel, link.getAttribute('data-catpanel-fetch'));
  }

  function resetSub(panel) {
    var all = panel.querySelector('.hdt-catpanel__sublink.is-all');
    if (all) selectSub(all);
  }

  /* Arrows page the row by whole cards; each hides at its end of the row. */
  function updateArrows(panel) {
    var grid = panel.querySelector('[data-catpanel-products]');
    if (!grid) return;
    var max = grid.scrollWidth - grid.clientWidth;
    panel.querySelectorAll('[data-catpanel-arrow]').forEach(function (btn) {
      var dir = +btn.getAttribute('data-catpanel-arrow');
      btn.hidden = max <= 1 || (dir < 0 ? grid.scrollLeft <= 1 : grid.scrollLeft >= max - 1);
    });
  }

  function page(panel, dir) {
    var grid = panel.querySelector('[data-catpanel-products]');
    var card = grid && grid.querySelector('.hdt-catpanel__card');
    if (!card) return;
    var pitch = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(grid).columnGap) || 0);
    var step = Math.max(1, Math.floor(grid.clientWidth / pitch)) * pitch;
    grid.scrollBy({ left: dir * step, behavior: 'smooth' });
  }

  /* A panel taller than the room under the header is given that room and
     scrolls inside it, so all of it can be read without the page moving.
     It is absolutely positioned, so nothing here feeds back into the
     header's own measured height. */
  function fit(panel) {
    if (!panel || panel.hidden) return;
    var room = window.innerHeight - panel.getBoundingClientRect().top - 8;
    panel.style.maxHeight = Math.max(240, room) + 'px';
    panel.style.overflowY = 'auto';
  }

  function open(trigger) {
    var panel = panelFor(trigger);
    if (!panel || current === panel) return;
    close();
    panel.hidden = false;
    fit(panel);
    trigger.setAttribute('aria-expanded', 'true');
    current = panel;
    // Each fresh open starts on the category's own row.
    resetSub(panel);
    load(panel);
    updateArrows(panel);
  }

  function close() {
    if (!current) return;
    current.hidden = true;
    var t = bar.querySelector('[aria-controls="' + current.id + '"]');
    if (t) t.setAttribute('aria-expanded', 'false');
    current = null;
  }

  function scheduleOpen(trigger) {
    clearTimeout(closeTimer); clearTimeout(openTimer);
    openTimer = setTimeout(function () { open(trigger); }, OPEN_DELAY);
  }
  function scheduleClose() {
    clearTimeout(openTimer); clearTimeout(closeTimer);
    closeTimer = setTimeout(close, CLOSE_DELAY);
  }

  bar.querySelectorAll('[data-catpanel-trigger]').forEach(function (trigger) {
    trigger.addEventListener('mouseenter', function () { scheduleOpen(trigger); });
    trigger.addEventListener('mouseleave', scheduleClose);
    // Keyboard: focusing a category opens its panel.
    trigger.addEventListener('focus', function () { open(trigger); });
  });

  bar.querySelectorAll('[data-catpanel]').forEach(function (panel) {
    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', scheduleClose);

    // A short delay so sweeping the pointer down the list does not fire a
    // fetch for every row it crosses.
    panel.querySelectorAll('[data-catpanel-fetch]').forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        clearTimeout(subTimer);
        subTimer = setTimeout(function () { selectSub(link); }, SUB_DELAY);
      });
      link.addEventListener('mouseleave', function () { clearTimeout(subTimer); });
      link.addEventListener('focus', function () { selectSub(link); });
    });

    panel.querySelectorAll('[data-catpanel-arrow]').forEach(function (btn) {
      btn.addEventListener('click', function () { page(panel, +btn.getAttribute('data-catpanel-arrow')); });
    });
    var grid = panel.querySelector('[data-catpanel-products]');
    if (grid) grid.addEventListener('scroll', function () { updateArrows(panel); }, { passive: true });
  });
  window.addEventListener('resize', function () { if (current) { updateArrows(current); fit(current); } });
  /* the room under a sticky header changes as the page moves */
  var fitting = false;
  window.addEventListener('scroll', function () {
    if (!current || fitting) return;
    fitting = true;
    requestAnimationFrame(function () { fitting = false; if (current) fit(current); });
  }, { passive: true });

  bar.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && current) {
      var t = bar.querySelector('[aria-controls="' + current.id + '"]');
      close();
      if (t) t.focus();
    }
  });

  // Close when focus or pointer leaves the header entirely.
  document.addEventListener('focusin', function (e) {
    if (current && !bar.contains(e.target)) close();
  });
  bar.addEventListener('mouseleave', scheduleClose);

  /* Scrolling used to dismiss the panel, which made a panel taller than the
     window impossible to read: the first turn of the wheel took it away. The
     header is sticky, so the panel travels with it and stays where it
     belongs - the page may now be scrolled with it open.

     What closes it instead is the pointer leaving the window altogether,
     for the browser's own chrome, another window or the desktop. A mouseout
     from the document with nothing to move to is that moment. */
  document.addEventListener('mouseout', function (e) {
    if (!current) return;
    if (e.relatedTarget || e.toElement) return;
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    close();
  });
})();
